import { CircleX, WifiOff } from '@/lib/icons'
import { Button } from '@/components/ui/button'
import { ApiError } from '@/lib/api'
import { cn } from '@/lib/utils'

/** Ma'lumot allaqachon ekranda bo'lsa (eskirgan holatda) ko'rsatiladigan yuqori banner. */
export function BroadcastErrorBanner({
  error,
  isFetching,
  onRetry,
}: {
  error: Error
  isFetching: boolean
  onRetry: () => void
}) {
  const isServerError = error instanceof ApiError
  return (
    <div className="flex items-center justify-between gap-3 rounded-card border border-urgency-overdue/30 bg-urgency-overdue/10 px-3 py-2 text-sm text-urgency-overdue-text">
      <span className="inline-flex items-center gap-2">
        <WifiOff size={16} aria-hidden="true" />
        {isServerError ? "Server bilan aloqa yo'q." : "Aloqa yo'q."}{' '}
        {isFetching ? 'Qayta urinilmoqda...' : "Ma'lumotlar eskirgan bo'lishi mumkin."}
      </span>
      <button
        type="button"
        onClick={onRetry}
        className="shrink-0 font-medium underline underline-offset-2"
      >
        Qayta urinish
      </button>
    </div>
  )
}

/** Birinchi yuklanish ham muvaffaqiyatsiz tugagan holat — ko'rsatadigan ma'lumot umuman yo'q. */
export function BroadcastRetryState({
  error,
  onRetry,
  className,
}: {
  error: Error | null
  onRetry: () => void
  className?: string
}) {
  const isServerError = error instanceof ApiError
  const Icon = isServerError ? CircleX : WifiOff
  const title = isServerError ? 'Server xatosi' : "Aloqa yo'q"
  const description = isServerError
    ? (error?.message ?? 'Kutilmagan xatolik yuz berdi.')
    : "Internet aloqasini tekshiring va qayta urinib ko'ring."

  return (
    <div
      className={cn(
        'mx-auto flex min-h-[30vh] max-w-sm flex-col items-center justify-center gap-3 text-center',
        className,
      )}
    >
      <Icon size={28} className="text-app-hint" aria-hidden="true" />
      <h2 className="text-base font-semibold">{title}</h2>
      <p className="text-sm text-app-hint">{description}</p>
      <Button className="mt-1" onClick={onRetry}>
        Qayta urinish
      </Button>
    </div>
  )
}
